import actions from './actions';
import reducer from './reducer';

const scheduledCases= {
    actions,
    reducer,
    name: 'scheduledCases',
};

export default scheduledCases; 